import { getField, updateField } from 'vuex-map-fields'
import FaqModel from '@/models/FaqModel'

export const state = {
  faqs: [],
}

export const mutations = { updateField }
export const getters = {
  getField,
}
export const actions = {
  async fetchFaqs() {
    try {
      await FaqModel.fetch()
    } catch (error) {
      throw Error(error)
    }
  }, // fetchFaqs
}
